import { render } from "./NoticeModal.vue?vue&type=template&id=1afd5384&scoped=true"
import script from "./NoticeModal.vue?vue&type=script&lang=js"
export * from "./NoticeModal.vue?vue&type=script&lang=js"

import "./NoticeModal.vue?vue&type=style&index=0&id=1afd5384&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd5384"]])

export default __exports__